import { Task, TaskType } from '@/lib/sdk/chatbot/types';
import { GridRow, blankRow } from './useTaskGridReducer';

const uuidv4 = () => crypto.randomUUID();

export function taskToImportRow(task: Task): GridRow {
  return {
    ...blankRow(),
    _localId: uuidv4(),
    name: task.name,
    description: task.description ?? '',
    type: task.type ?? TaskType.REGULAR,
    data: task.data ?? '',
  };
}

export interface ChatbotTaskRow {
  task_name: string;
  description?: string;
  type: string;
  group?: string;
}

export function importRowToGridRow(row: ChatbotTaskRow): GridRow {
  return {
    ...blankRow(),
    _localId: uuidv4(),
    name: row.task_name,
    description: row.description ?? '',
    type: (row.type as TaskType) ?? TaskType.REGULAR,
    group: row.group ?? '',
  };
}
